import React, { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';
import { Creators as requestStatusActions } from '../../../../../../../domain/useCases/procedures/getStudentProcedureStatus';
import routes from '../../../../../../components/Routes/routingMap';
import constants from '../../../../constants';
import RetirementPeriodInfoView from './RetirementPeriodInfoView';
import useExternalSettings from '@/presentation/hooks/useExternalSettings';

interface RouteParams {
  removeOfPeriod: string;
}

const RetirementOfPeriodInfoViewController: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { removeOfPeriod } = useParams<RouteParams>();

  const {
    procedure: procedureSelectedInfo,
    selectedProcedureId,
    isLoading
  } = useSelector((state: any) => state.procedureInformation);

  const { procedureWhiteList } = useExternalSettings();

  useEffect(() => {
    if (!procedureSelectedInfo) {
      const selectedRequest = (
        constants.categories.requests.procedureList as any[]
      ).find((p: any) => p.url === removeOfPeriod);
      const procedureId =
        selectedRequest?.procedureId ||
        constants.categories.requests.procedures.removeOfPeriod;
      dispatch(procedureActions.getProcedureInformation(procedureId));
    }
  }, [dispatch, procedureSelectedInfo, removeOfPeriod]);

  useEffect(() => {
    if (
      selectedProcedureId !== undefined &&
      !procedureWhiteList?.includes(selectedProcedureId.toString())
    ) {
      history.push(routes.student.procedures.home);
    }
  }, [selectedProcedureId, procedureWhiteList, history]);

  const [showModalConfirmation, setShowModalConfirmation] = useState(false);
  const [showModalNotAvailable, setShowModalNotAvailable] = useState(false);
  const [showModalError, setShowModalError] = useState(false);

  const handleNewRequest = useCallback(() => {
    if (procedureSelectedInfo?.disabled) setShowModalNotAvailable(true);
    else if (procedureSelectedInfo?.requestInProgress)
      setShowModalConfirmation(true);
    else if (procedureSelectedInfo?.error?.title) setShowModalError(true);
    else {
      history.push(
        routes.student.procedures.categories.requests.retirementperiod
          .procedureregister
      );
    }
  }, [procedureSelectedInfo, history]);

  const handleExistRequest = useCallback(() => {
    if (procedureSelectedInfo) {
      dispatch(
        requestStatusActions.getStudentProcedureStatus(
          constants.categories.requests.procedures.removeOfPeriod,
          procedureSelectedInfo.currentRequestId
        )
      );
    }
    history.push(
      routes.student.procedures.categories.requests.retirementperiod
        .procedureprogress
    );
  }, [dispatch, procedureSelectedInfo, history]);

  const handleBack = useCallback(
    () => history.push('/tramites/solicitudes'),
    [history]
  );
  const handleCloseModalConfirmation = useCallback(
    () => setShowModalConfirmation(false),
    []
  );
  const handleCloseModalNotAvailable = useCallback(
    () => setShowModalNotAvailable(false),
    []
  );
  const handleCloseModalError = useCallback(() => setShowModalError(false), []);

  return (
    <RetirementPeriodInfoView
      isLoading={isLoading}
      handleCloseModalConfirmation={handleCloseModalConfirmation}
      handleCloseModalNotAvailable={handleCloseModalNotAvailable}
      handleBack={handleBack}
      handleNewRequest={handleNewRequest}
      handleExistRequest={handleExistRequest}
      handleCloseModalError={handleCloseModalError}
      showModalConfirmation={showModalConfirmation}
      showModalNotAvailable={showModalNotAvailable}
      procedureSelectedInfo={procedureSelectedInfo}
      showModalError={showModalError}
      modalTitle={procedureSelectedInfo?.error?.title}
    />
  );
};

export default RetirementOfPeriodInfoViewController;
